const today = new Date().toISOString().split("T")[0];

export const initialFormData = {
  acquirer: {
    iso: "",
    isoID: "",
    currency: "",
    holding: "",
    holdingId: "",
    group: "",
    groupId: "",
    name: "",
    store: "",
    address: "",
    neighborhood: "",
    city: "",
    merchantState: "",
    postalCode: "",
    mccID: "",
    merchantID: "",
    amountOther: "",
    terminal: {
      terminals: [{ terminalID: "", terminalType: "", terminalSerial: "" }],
    },
  },
  merchant: {
    legal_name: "",
    business_email: "",
    business_phone: "",
    business_type: "",
    taxpayer_id: "",
    incorporation_date: today,
    effective_date: today,
    amount_tx_processing: "",
    amount_tx_processing_tiers: "0",
    percent_tx_processing: "",
    percent_tx_processing_tiers: "0",
    amount_terminal_maintenance: "0",
    amount_terminal_maintenance_tiers: "0",
    terminal_maintenance_inactive: "False",
    amount_terminal_setup: "0",
    amount_terminal_setup_tiers: "0",
  },
  bank: {
    bid: "",
    swift_code: "",
    account_number: "",
    address: "",
    routing_number: "",
    iban: "",
    branch_number: "",
    city: "",
    state: "",
    country_code: "",
    postal_code: "",
  },
  owner: [
    {
      first_name: "",
      last_name: "",
      middle_name: "",
      id: "",
      taxpayer_id: "",
      percentage: "0",
      id_issuer: "",
      personal_email: "",
      personal_phone: "",
      address: "",
      city: "",
      state: "",
      country: "",
      postal_code: "",
      neighborhood: "",
      residency_time: "00",
    },
  ],
};
